<template>
  <div id="adminContainer">
    <div class="inner">
      <div
        style="
          width: 6px;
          height: 20px;
          background: #464775;
          float: left;
          margin-right: 10px;
        "
      ></div>
      <div style="float: left; position: relative; top: -4px">
        <h3 class="pr-3" style="font-weight: 600">사용자 관리</h3>
      </div>
      <div
        style="
          clear: both;
          width: 99%;
          height: 2.5px;
          background-color: #e9e9e9;
        "
      ></div>
      <!--tbw-->
      <div class="tabContent">
        <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin-bottom: 15px; margin-left: 10px;">
          <div style="display:flex; flex-direction: row">
            <input class="search-inputbox" style="width: 150px;" type="text" placeholder="사용자로 검색" v-model="filter.searchText" @keyup.enter="searchUser()">
            <input class="search-inputbox" style="width: 150px;" type="text" placeholder="부서로 검색" v-model="filter.searchDept" @keyup.enter="searchUser()">

            <div class="inputbox fl">
              <select
                class="formbox-select"
                style="
                  background-color: white;
                  width: 150px;
                  height: 30px;
                  margin-left: 10px;
                "
                v-model="filter.authorize"
              >
                <option
                  v-for="roleData in filterAuthorizeList"
                  :key="roleData.value"
                  :value="roleData.value"
                >
                  {{ roleData.text }}
                </option>
              </select>
            </div>
            <button class="btnPrimary" @click="searchUser(true)">검색</button>
          </div>
          <div>
            <!-- <button style="background-color: #464775; color: white; border-radius: 5px;" @click="accessUser('open')">전체 접속허용</button>
            <button style="background-color: brown; color: white; border-radius: 5px; margin-right: 20px;" @click="accessUser('close')">전체 접속불가</button> -->
            <img
              src="/static/seoul/img/excel.png"
              style="
                float: right;
                width: 30px;
                cursor: pointer;
                margin-right: 20px;
              "
              @click="exportUserList()"
            />
          </div>
        </div>

        <!--tbw_tb01-->
        <div class="tbw_tb01">
          <table>
            <caption>
              회의리스트
            </caption>
            <thead>
              <tr>
                <!-- <th :style="{width: '7%'}">선택</th> -->
                <th :style="{width: '7%'}" style="cursor: pointer;">부서</th>
                <th :style="{width: '5%'}" style="cursor: pointer;">직급</th>
                <th :style="{width: '5%'}" style="cursor: pointer;" @click="sortName()">이름<v-icon color="gray">{{ nameSort === 'desc' ? 'arrow_upward' : 'arrow_downward' }}</v-icon></th>
                <th :style="{width: '5%'}" style="cursor: pointer;" @click="sortAuthority()">권한<v-icon color="gray">{{ nameSort === 'desc' ? 'arrow_upward' : 'arrow_downward' }}</v-icon></th>
                <th :style="{width: '5%'}" style="cursor: pointer;">접근허용</th>
                <!-- <th :style="{width: '8%'}">라이센스 상태</th> -->
                <!-- <th :style="{width: '8%'}" style="cursor: pointer;" @click="sortApproval()">사용자 승인<v-icon color="gray">{{ approvalSort === 'desc' ? 'arrow_upward' : 'arrow_downward' }}</v-icon></th> -->
                <th :style="{ width: '7%' }" style="cursor: pointer">
                  화상장비1
                </th>
                <th :style="{ width: '7%' }" style="cursor: pointer">
                  화상장비2
                </th>
                <!-- <th :style="{width: '8%'}">승인취소</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(listItem, index) in filterLimitUser" :key="index">
                <!-- <td>
                  <div class="btn_check_box" style="padding-top: 0">
                    <label v-bind:for="listItem" class="container-checkbox">
                      <input type="checkbox" v-model="checkedMembers" :label="listItem" v-bind:value="listItem">
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </td> -->
                <td>{{ listItem.department }}</td>
                <td>{{ listItem.grade }}</td>
                <td>{{ listItem.name ? listItem.name : listItem.username }}</td>
                <td>
                  <!--selectbox -->
                  <select
                    class="formbox-select"
                    style="width: 150px; height: 30px"
                    v-model="listItem.authorize"
                    @change="roleChange(listItem)"
                  >
                    <option
                      v-for="roleData in roleList"
                      :key="roleData.value"
                      :value="roleData.value"
                    >
                      {{ roleData.text }}
                    </option>
                  </select>
                  <!--//selectbox -->
                </td>
                <td>
                  <!--selectbox -->
                  <select
                    class="formbox-select"
                    style="width: 150px; height: 30px"
                    v-model="listItem.status"
                    @change="accessChange(listItem)"
                  >
                    <option
                      v-for="roleData in accessList"
                      :key="roleData.value"
                      :value="roleData.value"
                    >
                      {{ roleData.text }}
                    </option>
                  </select>
                  <!--//selectbox -->
                </td>
                <!-- <td>{{ listItem.isAssigned ? '할당' : '미할당' }}</td> -->
                <!-- <td v-if="listItem.isAssigned"><a class="icocom delete_ico" @click="retrieveLicense(listItem)"></a></td> -->
                <td>
                  <select
                    class="formbox-select"
                    style="width: 150px; height: 30px"
                    v-model="listItem.deviceId"
                    @change="deviceChange(listItem)"
                  >
                    <option
                      v-for="roleData in deviceList"
                      :key="roleData._id"
                      :value="roleData._id"
                    >
                      {{ roleData.deviceName }}
                    </option>
                  </select>
                </td>
                <td>
                  <select
                    class="formbox-select"
                    style="width: 150px; height: 30px"
                    v-model="listItem.secondDeviceId"
                    @change="deviceChange(listItem)"
                  >
                    <option
                      v-for="roleData in deviceList"
                      :key="roleData._id"
                      :value="roleData._id"
                    >
                      {{ roleData.deviceName }}
                    </option>
                  </select>
                </td>
                <!-- <td><a class="icocom modi_ico" @click="modifyProfile(listItem)"></a></td> -->
                <!-- <td><a class="icocom delete_ico" @click="deleteUser(listItem)"></a></td> -->
              </tr>
            </tbody>
          </table>
          <!--total_num-->
          <div class="total_num">
            <p>
              <span>Rows per page :</span
              ><span style="padding-right: 10px">{{ perPage }}</span
              ><span>Total : </span><span>{{ userList.length }}</span>
            </p>
          </div>
          <!--total_num-->
        </div>
        <!--//tbw_tb01-->
        <div class="paging">
          <div class="boardnavi">
            <pagination
              :records="userList.length"
              v-model="page"
              :per-page="perPage"
            />
          </div>
        </div>
      </div>
      <!--//tbw-->
    </div>
    <warning-dialog
      :dialog="warningDialog.dialog"
      :title="warningDialog.title"
      :content="warningDialog.content"
      :closeDialog="closeWarningDialog"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import Util from '@/util';
import VModal from 'vue-js-modal';
import Pagination from 'vue-pagination-2';
// import ExcelCreateUsersDialog from '@/components/popup/ExcelCreateUsersDialog';
// import ExcelCreateOrganizationsDialog from '@/components/popup/ExcelCreateOrganizationsDialog';
import WarningDialog from '@/components/popup/WarningDialog';
Vue.use(VModal);

export default {
  components: {
    // ExcelCreateUsersDialog,
    // ExcelCreateOrganizationsDialog,
    WarningDialog,
    Pagination,
  },
  data: () => ({
    page: 1,
    perPage: 8,
    deptSort: 'desc',
    nameSort: 'desc',
    authorize: 'desc',
    orgaSort: 'desc',
    gpkiSort: 'desc',
    approvalSort: 'desc',
    userList: [],
    checkedMembers: [] /* 체크박스 유저 정보 */,
    modifyProfileDialog: {
      dialog: false,
      userInfo: {},
    },
    /* 사용자 검색 */
    filter: {
      searchText: null,
      authorize: 'All',
      licenses: 'All',
    },
    searchedFilter: {
      searchText: null,
      authorize: 'All',
      licenses: 'All',
    },
    filterAuthorizeList: [
      { text: '권한 전체', value: 'All' },
      { text: '관리자', value: 'a' },
      { text: '사용자', value: 'u' },
    ],
    filterLicense: [
      { text: '라이선스 전체', value: 'All' },
      { text: '할당', value: 'assigned' },
      { text: '미할당', value: 'unAssigned' },
    ],

    /* 조직도(기관) Import */
    excelCreateOrgansDialog: {
      dialog: false,
    },
    /* 사용자 Upload */
    excelCreateUsersDialog: {
      dialog: false,
      siteName: null,
    },

    /* 삭제  */
    warningDialog: {
      dialog: false,
      title: '승인취소',
      content: '',
      delId: null,
      isDelUser: true,
    },

    /* 조직도 업로드 */
    excelCreateOrganizationsDialog: {
      dialog: false,
      siteName: null,
    },

    /* 사용자 권한 설정 */
    roleList: [
      { value: 'u', text: '사용자' },
      { value: 'a', text: '관리자' },
    ],
    accessList: [
      { value: 'u', text: '접속가능' },
      { value: 'a', text: '접속불가' },
    ],

    deviceList: [],
  }),
  computed: {
    filterLimitUser() {
      let page = this.page;
      let startPage = (page - 1) * this.perPage;
      let limitPage = startPage + this.perPage;

      return this.userList.slice(startPage, limitPage);
    },
  },
  async created() {
    // this.axios.get('http://localhost:8080/server/listTest.json')
    //   .then((response) => {
    //     this.listData = response.data;
    //     console.log(this.listData);
    //   });
  },
  async activated() {
    if (!Util.hasSession(this)) return;
    if (this.$store.state.user.authorize !== 'a') {
      this.$router.push('/');
    }
    this.filter = {
      searchText: null,
      authorize: 'All',
      licenses: 'All',
      searchDept: null,
    };
    this.searchedFilter = {
      searchText: null,
      authorize: 'All',
      licenses: 'All',
    };
    this.page = 1;
    this.initUserList();
  },
  methods: {
    async initUserList() {
      let params = {};
      if (this.searchedFilter.searchText) {
        params['search'] = this.searchedFilter.searchText;
      }
      if (
        this.searchedFilter.authorize &&
        this.searchedFilter.authorize !== 'All'
      ) {
        params['authorize'] = this.searchedFilter.authorize;
      }
      if (
        this.searchedFilter.licenses &&
        this.searchedFilter.licenses !== 'All'
      ) {
        params['isAssigned'] =
          this.searchedFilter.licenses === 'assigned' ? true : false;
      }

      this.$http
        .get(`/api/v1/organizations`, { params: params })
        .then((response) => {
          this.userList = response.data;
          console.log(this.userList);
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });

      this.$http
        .get(`/api/v1/devices`)
        .then((response) => {
          this.deviceList = response.data;
          this.deviceList.unshift({ _id: '', deviceName: '사용안함' });
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    async searchUser(isInitPage) {
      if (isInitPage) {
        this.page = 1;
      }
      let params = {};
      if (this.filter.searchText) {
        params['search'] = this.filter.searchText;
      }

      if (this.filter.authorize && this.filter.authorize !== 'All') {
        params['authorize'] = this.filter.authorize;
      }
      if (this.filter.licenses && this.filter.licenses !== 'All') {
        params['isAssigned'] =
          this.filter.licenses === 'assigned' ? true : false;
      }

      if (this.filter.searchDept) {
        // 부서
        params['search'] = this.filter.searchDept;
      }

      this.searchedFilter = Object.assign({}, this.filter);

      console.log(params);
      this.$http
        .get(`/api/v1/organizations`, { params: params })
        .then((response) => {
          this.userList = response.data;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    async openAddUsersPopup() {
      this.excelCreateUsersDialog.siteName = this.$store.state.user.siteName;
      this.excelCreateUsersDialog.dialog = true;
    },
    excelCreateOrgansClose(isInit) {
      this.excelCreateOrgansDialog.dialog = false;
      if (isInit) {
        this.initUserList();
      }
    },
    async exportUserList () {
      let items = [];
      // this.userList.forEach((user) => {
      //   items.push({
      //     dept: user.DEPT_NM,
      //     name: user.name,
      //     status: user.status === 'a' ? '승인됨' : '승인안됨',
      //     useDevice: user.useDevice === true ? '사용중' : '-'
      //   });
      // });
      // let title = `사용자 관리`
      // let body = {
      //   title: title,
      //   userId: this.$store.state.user.empNum,
      //   items: items,
      //   type: 'manageUsers'
      // }
      // await this.$http.post('/api/v1/meetings/ksd/adminListToDocument', body).then((response) => {
      //   if (response) {
      //     alert(`문서중앙화로 전송 완료 - 파일위치 : 스마트회의 관리자/${title}.xlsx`);
      //   }
      // }).catch((error) => {
      //   console.log(error);
      // });
      let columns = [
        { header: '부서', key: 'dept', width: 20 },
        { header: '이름', key: 'name', width: 20 },
        { header: '상태', key: 'status', width: 20 },
        { header: '영상장비 사용여부', key: 'useDevice', width: 20 },
      ];

      this.userList.forEach((user) => {
        items.push({
          dept: user.DEPT_NM,
          name: user.name,
          status: user.status === 'a' ? '승인됨' : '승인안됨',
          useDevice: user.useDevice === true ? '사용중' : '-',
        });
      });
      console.log(items);
      
      Util.exportExcel('사용자 관리', columns, items, true, '사용자 관리.xlsx');
    },
    // excelCreateUsersClose (isInit) {
    //   if (isInit) {
    //     this.initUserList();
    //   }
    //   this.excelCreateUsersDialog.dialog = false;
    // },
    // async openAddOrganizationsPopup () {
    //   this.excelCreateOrganizationsDialog.siteName = this.$store.state.user.siteName;
    //   this.excelCreateOrganizationsDialog.dialog = true;
    // },
    // excelCreateOrganizationsClose (isInit) {
    //   if (isInit) {
    //     this.initUserList();
    //   }
    //   this.excelCreateOrganizationsDialog.dialog = false;
    // },
    openOrgansPopup() {
      this.excelCreateOrgansDialog.dialog = true;
    },
    async modifyProfile(userInfo) {
      let params = {};
      params['email'] = userInfo.email;
      this.$http
        .post(`/api/v1/users/selectUser`, params)
        .then((response) => {
          console.log(response.data);
          this.modifyProfileDialog.dialog = true;
          this.modifyProfileDialog.userInfo = response.data;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    closeModifyProfileDialog() {
      this.modifyProfileDialog.dialog = false;
    },
    changedProfile(editedUserInfo) {
      this.userInfo = Object.assign({}, editedUserInfo);
    },
    deleteUser(delItem) {
      this.warningDialog.content = `${delItem.username}을 <br>승인 취소 하시겠습니까?`;
      this.warningDialog.delId = delItem.email;
      this.warningDialog.isDelUser = true;
      this.warningDialog.dialog = true;
    },
    closeWarningDialog(ret) {
      if (ret === 'ok') {
        // 사용자 삭제
        let params = {
          ids: [this.warningDialog.delId],
        };

        if (this.warningDialog.isDelUser) {
          this.$http
            .delete(`/api/v1/users/login/users`, { params: params })
            .then((response) => {
              if (response.data === 'ok') {
                // 삭제 성공
                Util.snackBarOpen('사용자 승인 취소 되었습니다', 'success');
                this.searchUser(false);
              } else {
                // 삭제 실패
                Util.snackBarOpen('사용자 삭제 실패', 'error');
              }
            })
            .catch((error) => {
              console.log(error.response.data.error);
            });
        } else {
          this.$http
            .post(`/api/v1/users/retrieve/license`, params)
            .then((response) => {
              if (response.data === 'ok') {
                // 삭제 성공
                Util.snackBarOpen('라이선스가 회수 되었습니다', 'success');
                this.initUserList();
              } else {
                // 삭제 실패
                Util.snackBarOpen('라이선스가 회수 실패', 'error');
              }
            })
            .catch((error) => {
              console.log(error.response.data.error);
            });
        }
      }
      this.warningDialog.delId = null;
      this.warningDialog.dialog = false;
    },
    retrieveLicense(item) {
      this.warningDialog.title = `라이선스 삭제`;
      this.warningDialog.content = `${item.email}의 라이선스를 <br>삭제 하시겠습니까?`;
      this.warningDialog.delId = item._id;
      this.warningDialog.dialog = true;
      this.warningDialog.isDelUser = false;
    },
    assignLicense(item) {
      let params = {
        ids: [item._id],
        siteName: item.siteName,
      };
      this.$http
        .post(`/api/v1/users/assignLicenses`, params)
        .then((response) => {
          if (response.data === 'ok') {
            // 삭제 성공
            Util.snackBarOpen('라이선스가 할당 되었습니다', 'success');
            this.initUserList();
          } else {
            // 삭제 실패
            Util.snackBarOpen('라이선스가 할당 실패', 'error');
          }
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    sortDept() {
      if (this.deptSort === 'asc') {
        this.deptSort = 'desc';
        this.userList.sort((a, b) => {
          return a.displayFullName > b.displayFullName
            ? -1
            : b.displayFullName > a.displayFullName
            ? 1
            : 0;
        });
      } else {
        this.deptSort = 'asc';
        this.userList.sort((a, b) => {
          return a.displayFullName < b.displayFullName
            ? -1
            : b.displayFullName < a.displayFullName
            ? 1
            : 0;
        });
      }
    },
    sortName() {
      if (this.nameSort === 'asc') {
        this.nameSort = 'desc';
        this.userList.sort((a, b) => {
          return a.name > b.name ? -1 : b.name > a.name ? 1 : 0;
        });
      } else {
        this.nameSort = 'asc';
        this.userList.sort((a, b) => {
          return a.name < b.name ? -1 : b.name < a.name ? 1 : 0;
        });
      }
    },
    sortAuthority() {
      if (this.authorizeSort === 'asc') {
        this.authorizeSort = 'desc';
        this.userList.sort((a, b) => {
          return a.authorize > b.authorize
            ? -1
            : b.authorize > a.authorize
            ? 1
            : 0;
        });
      } else {
        this.authorizeSort = 'asc';
        this.userList.sort((a, b) => {
          return a.authorize < b.authorize
            ? -1
            : b.authorize < a.authorize
            ? 1
            : 0;
        });
      }
    },
    sortOrga() {
      if (this.orgaSort === 'asc') {
        this.orgaSort = 'desc';
        this.userList.sort((a, b) => {
          return a.organCategory > b.organCategory
            ? -1
            : b.organCategory > a.organCategory
            ? 1
            : 0;
        });
      } else {
        this.orgaSort = 'asc';
        this.userList.sort((a, b) => {
          return a.organCategory < b.organCategory
            ? -1
            : b.organCategory < a.organCategory
            ? 1
            : 0;
        });
      }
    },
    sortGpki() {
      if (this.gpkiSort === 'asc') {
        this.gpkiSort = 'desc';
        this.userList.sort((a, b) => {
          let gpkiType =
            a.certKey.indexOf('서울특별시') !== -1 ? 'GPKI' : 'NPKI';
          let gpkiType2 =
            b.certKey.indexOf('서울특별시') !== -1 ? 'GPKI' : 'NPKI';
          return gpkiType > gpkiType2 ? -1 : gpkiType2 > gpkiType ? 1 : 0;
        });
      } else {
        this.gpkiSort = 'asc';
        this.userList.sort((a, b) => {
          let gpkiType =
            a.certKey.indexOf('서울특별시') !== -1 ? 'GPKI' : 'NPKI';
          let gpkiType2 =
            b.certKey.indexOf('서울특별시') !== -1 ? 'GPKI' : 'NPKI';
          return gpkiType < gpkiType2 ? -1 : gpkiType2 < gpkiType ? 1 : 0;
        });
      }
    },
    sortApproval() {
      if (this.approvalSort === 'asc') {
        this.approvalSort = 'desc';
        this.userList.sort((a, b) => {
          let status = a.status;
          let status2 = b.status;
          return status > status2 ? -1 : status2 > status ? 1 : 0;
        });
      } else {
        this.approvalSort = 'asc';
        this.userList.sort((a, b) => {
          let status = a.status;
          let status2 = b.status;
          return status < status2 ? -1 : status2 < status ? 1 : 0;
        });
      }
    },
    assignLicenses() {
      if (!this.checkedMembers || this.checkedMembers.length === 0) {
        return alert('사용자를 선택 하세요');
      }
      if (
        this.checkedMembers.filter((c) => c.isAssigned === true).length >= 1
      ) {
        return alert('라이선스 미할당 사용자만 체크 하세요');
      }

      let params = {
        ids: this.checkedMembers.map((c) => c._id),
        siteName: this.$store.state.user.siteName,
      };
      this.$http
        .post(`/api/v1/users/assignLicenses`, params)
        .then((response) => {
          if (response.data === 'ok') {
            // 삭제 성공
            Util.snackBarOpen('라이선스가 할당 되었습니다', 'success');
            this.initUserList();
          } else {
            // 삭제 실패
            Util.snackBarOpen('라이선스가 할당 실패', 'error');
          }
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    approveClick(item) {
      console.log(`roleChange`, item);
      let params = {
        status: 'a',
      };
      this.$http
        .post(`/api/v1/users/approve/${item.email}`, params)
        .then((response) => {
          if (response.data === 'ok') {
            Util.snackBarOpen('사용자 승인이 완료 되었습니다.', 'success');
            this.searchUser(false);
          } else {
            Util.snackBarOpen('사용자 승인이 실패하였습니다.', 'error');
          }
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    roleChange(item) {
      let params = {
        authorize: item.authorize,
      };

      this.$http
        .post(`/api/v1/users/${item.email}`, params)
        .then((response) => {
          if (response.data === 'ok') {
            Util.snackBarOpen('권한이 변경 되었습니다.', 'success');
          } else {
            Util.snackBarOpen('권한 변경이 실패 하였습니다.', 'error');
            this.initUserList();
          }
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    accessChange(item) {
      let params = {
        status: item.status,
      };

      this.$http
        .put(`/api/v1/users/access/${item.email}`, params)
        .then((response) => {
          if (response.data === 'ok') {
            Util.snackBarOpen('접근 허용 되었습니다.', 'success');
          } else {
            Util.snackBarOpen('접근 허용 변경이 실패 하였습니다.', 'error');
            this.initUserList();
          }
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    accessUser (type) {
      let params = {
      };

      if (type === 'open') {
        params['status'] = 'u';
      } else {
        params['status'] = 'a';
      }

      this.$http
        .post(`/api/v1/users/accessChange`, params)
        .then((response) => {
          if (response.data === 'ok') {
            Util.snackBarOpen('접근 허용 되었습니다.', 'success');
          } else {
            Util.snackBarOpen('접근 허용 변경이 실패 하였습니다.', 'error');
            this.initUserList();
          }
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    deviceChange(item) {
      this.$http
        .post('/api/v1/organizations/updateDevice', item)
        .then((response) => {
          if (response.data === 'ok') {
            Util.snackBarOpen('화상장비 갱신 완료하였습니다.', 'success');
          } else {
            Util.snackBarOpen('화상장비 변경이 실패 하였습니다.', 'error');
            this.initUserList();
          }
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
  },
};
</script>

<style scoped lang="stylus">
/* 체크박스 */
.btn_check_box > .container-checkbox {
    display: block;
    position: relative;
    cursor: pointer;
    font-size: 17px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    float: left;
    margin-right: 10px;
    font-size: 17px;
    width: 100%;
}

.btn_check_box > .container-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    width: 100%;
    height: 30px;
    z-index: 100;
    top: -16px;
    right: 0px;
}

.btn_check_box > .container-checkbox .checkmark {
    position: absolute;
    border: 1px solid #7f7f7f;
    display: inline-block;
    width: 15px;
    height: 15px;
    background: #fff;
    cursor: pointer;
    border-radius: 3px;
    top: -10px;
    right: 18px;
}

/* On mouse-over, add a grey background color */
.btn_check_box > .container-checkbox:hover input ~ .checkmark {

}

/* When the checkbox is checked, add a blue background */
.btn_check_box > .container-checkbox input:checked ~ .checkmark {
    background-color: white;
}

/* Create the checkmark/indicator (hidden when not checked) */
.btn_check_box > .container-checkbox .checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.btn_check_box > .container-checkbox input:checked ~ .checkmark:after {
    display: block;
    content: '';
    top: 1px;
    left: 1px;
    width: 13px;
    height: 13px;
    background: #fa4242;
    border-radius: 3px;
}

/* Style the checkmark/indicator */
.btn_check_box > .container-checkbox .checkmark:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border-width: 0 3px 3px 0;

}

.btn_check_box {
  padding-top: 4px;
}

/* pagenation */
.page-link{
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/pages/admin/sections/ManageUsers.vue